<template>
  <section>
    <b-row class="flex-wrap">
      <b-col lg="4" class="d-flex px-50">
        <submit-report
          class="w-100"
          @showReportModal="visible = true"
          v-if="userData && userData.type == 'partner'"
        />
        <competition-holder-live
          class="w-100"
          v-else
          :loading="holderLoading"
          :holder="holder"
        />
      </b-col>
      <b-col lg="4" class="d-flex px-50">
        <all-time-top-gainers
          class="w-100"
          :loading="loading"
          :analytics="analytics"
        />
      </b-col>
      <b-col lg="4" class="d-flex px-50">
        <safest-traders-by-drawdown
          class="w-100"
          :loading="loading"
          :analytics="analytics"
        />
      </b-col>

      <b-col lg="6" class="d-flex px-50">
        <div class="w-100">
          <b-col class="d-flex px-50" lg="12">
            <total-profits-made-by-participants class="w-100" />
          </b-col>
          <b-col class="d-flex px-50" lg="12">
            <audience-growth-over-time class="w-100" />
          </b-col>
        </div>
      </b-col>
      <b-col lg="6" class="d-flex px-50">
        <Most-traded-symbols
          class="w-100"
          :loading="loading"
          :analytics="analytics"
        />
      </b-col>
      <b-col lg="2" cols="12" class="d-flex px-50">
        <total-win-to-loss-ratio
          :loading="loading"
          :analytics="analytics"
          class="w-100"
        />
      </b-col>
      <b-col lg="2" class="d-flex px-50">
        <total-sell-to-buy-ratio
          :loading="loading"
          :analytics="analytics"
          class="w-100"
        />
      </b-col>
      <b-col lg="4" offset-lg="" class="d-flex px-50">
        <competitions-summary
          class="w-100"
          :loading="loading"
          :analytics="analytics"
        />
      </b-col>
      <b-col lg="4" class="d-flex px-50">
        <participants-summary
          class="w-100"
          :loading="loading"
          :analytics="analytics"
        />
      </b-col>
      <b-card class="w-100">
        <div
          class="w-100 d-flex align-items-center justify-content-between flex-wrap"
        >
          <div
            class="w-100 filters rounded p-md-2 p-50 my-1 d-flex align-items-center flex-wrap"
          >
            <div class="p-50 col-md-2 col-6">
              <b-button
                @click="show = 'participants'"
                :class="['w-100', show == 'participants' && 'gradient-btn']"
                type="button"
              >
                <span class="h5"> Participants</span>
              </b-button>
            </div>
            <div
              class="p-50 col-md-2 col-6"
              v-if="analytics.summery && analytics.summery.active"
            >
              <b-button
                @click="show = 'trades'"
                :class="['w-100', show == 'trades' && 'gradient-btn']"
                type="button"
              >
                <span class="h5"> Open Trades</span>
              </b-button>
            </div>
            <div
              class="p-50 col-md-2 col-6"
              v-if="$store.state.auth.userData.type === 'admin'"
            >
              <b-button @click="openOrder" class="w-100" type="button">
                <span class="h5"> Open Oreders</span>
              </b-button>
            </div>
            <div
              class="p-50 col-md-2 col-6"
              v-if="$store.state.auth.userData.type === 'admin'"
            >
              <b-button @click="openHistory" class="w-100" type="button">
                <span class="h5"> Order Historys</span>
              </b-button>
            </div>
            <!-- <b-form class="  p-50 col-md-6 col-8">
              <b-form-input placeholder="search" />
            </b-form>
            <div class="p-50  col-md-2 col-4">
              <b-button class="w-100" type="submit">
                <span class="text-muted h5"> Filtering</span>
              </b-button>
            </div> -->
          </div>
        </div>
        <participants-table class="w-100" v-if="show == 'participants'" />

        <open-trades
          class="w-100"
          v-else-if="analytics.summery && analytics.summery.active"
        />
      </b-card>
    </b-row>
    <report-form-modal :visible="visible" v-model="visible" />
    <modal-open-orders
      v-if="showModalOpenOrder"
      :showModal="showModalOpenOrder"
      @close="showModalOpenOrder = false"
    />
    <modal-open-orders
      v-if="showModalOpenOrder"
      :showModal="showModalOpenOrder"
      @close="showModalOpenOrder = false"
    />
    <modal-open-history
      v-if="showModalOpenHistory"
      :showModal="showModalOpenHistory"
      @close="showModalOpenHistory = false"
    />
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  VBTooltip,
  BButton,
  BCard,
  BForm,
  BFormInput,
} from "bootstrap-vue";
import AllTimeTopGainers from "./AllTimeTopGainers.vue";
import SafestTradersByDrawdown from "./SafestTradersByDrawdown.vue";
import MostTradedSymbols from "./MostTradedSymbols.vue";
import CompetitionsSummary from "./CompetitionsSummary.vue";
import TotalWinToLossRatio from "./TotalWinToLossRatio.vue";
import TotalSellToBuyRatio from "./TotalSellToBuyRatio.vue";
import TotalProfitsMadeByParticipants from "./TotalProfitsMadeByParticipants.vue";
import AudienceGrowthOverTime from "./AudienceGrowthOverTime.vue";
import SubmitReport from "./SubmitReport.vue";
import ParticipantsSummary from "./ParticipantsSummary.vue";
import ParticipantsTable from "./ParticipantsTable.vue";
import OpenTrades from "./OpenTrades.vue";
import ReportFormModal from "./ReportFormModal.vue";
import CompetitionHolderLive from "../competition-live/CompetitionHolderLive.vue";
import modalOpenOrders from "./modalOpenOrders.vue";
import modalOpenHistory from "./modalOpenHistory.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormInput,
    AllTimeTopGainers,
    SafestTradersByDrawdown,
    MostTradedSymbols,
    CompetitionsSummary,
    TotalWinToLossRatio,
    TotalSellToBuyRatio,
    TotalProfitsMadeByParticipants,
    AudienceGrowthOverTime,
    SubmitReport,
    ParticipantsSummary,
    ParticipantsTable,
    OpenTrades,
    ReportFormModal,
    CompetitionHolderLive,
    modalOpenOrders,
    modalOpenHistory,
  },
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      analytics: {},
      loading: false,
      visible: false,
      holderLoading: false,
      holder: {},
      show: "participants",
      showModalOpenOrder: false,
      showModalOpenHistory: false,
      modalTitle: "",
      orderData: {},
    };
  },
  methods: {
    openOrder() {
      this.showModalOpenOrder = true;
    },
    openHistory() {
      this.showModalOpenHistory = true;
    },
    async getHolder() {
      this.holderLoading = true;
      try {
        const { data } = await this.$http.get(
          `/panel/competitions/${this.$route.params.id}/partner`
        );
        this.holder = data.data;
      } catch (error) {}
      this.holderLoading = false;
    },
    async getAnalytics() {
      this.loading = true;

      try {
        const { data } = await this.$http.get(
          `/panel/competitions/${this.$route.params.id}/analytics`
        );
        this.analytics = data;
      } catch (err) {}
      this.loading = false;
    },
  },
  created() {
    this.getAnalytics();
    this.getHolder();
  },
}; 
</script>
<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
